<media-item-header></media-item-header>

<div class="container main-container">
    <article class="news-article" *ngIf="article$ | async as article">
        <ad-host slot="ads.shared" class="shared-ad-host"></ad-host>

        <h1 class="title">
            <a class="title" [routerLink]="urls.mediaItem(article)">{{article.title}}</a>
               </h1>
        <div class="meta">
            <div class="date">{{article.created_at | formattedDate}}</div>
            <ng-container *ngIf="article?.meta?.source">
                <div class="separator"></div>
                <div class="source">{{article.meta.source}}</div>
            </ng-container>
        </div>
        <div class="content">
            <img [src]="article?.meta?.image" class="main-image">
            <div class="body" [innerHTML]="trustHtml(article.body)"></div>
        </div>
    </article>

    <aside class="sidebar">
        <div class="header" trans>Recent blog</div>
        <div class="articles">
            <div class="article" *ngFor="let article of sidebarArticles$ | async">
                <img [src]="article?.meta?.image">
                <div class="meta">
                     <a class="title" [routerLink]="urls.mediaItem(article)">{{article.title}}</a>
                    <div class="subtitle">
                        <ng-container *ngIf="article?.meta?.source">
                            <span class="source"> {{article.meta.source}}</span>
                        </ng-container>
                        <span>{{article.created_at | formattedDate}}</span>
                    </div>
                </div>
            </div>
        </div>
             <div class="header" trans>Blog categories</div>
        <div class="articles blog-cat">
            <div class="article blog-cat">
             <a class="title cat-font" href="https://www.mycinehub.com/category/movies">Movies</a>
                  </div>
                 <div class="article blog-cat">
         <a class="title cat-font" href="https://www.mycinehub.com/category/tv-Series">Tv-Series</a>
     </div>
         <div class="article blog-cat">
     <a class="title cat-font" href="https://www.mycinehub.com/category/watch-list">Watch list</a>
 </div>
     <div class="article blog-cat">
             <a class="title cat-font" href="https://www.mycinehub.com/category/reviews">Reviews</a>
         </div>
             <div class="article blog-cat">
          <a class="title cat-font" href="https://www.mycinehub.com/category/celebrity">Celebrity</a>    
                </div>
            </div>
    </aside>

    <loading-indicator [isVisible]="loading$ | async" class="overlay overlay-light"></loading-indicator>
</div>

<footer></footer>